module.exports = __webpack_public_path__ + "img/teachersbyalternatives_hover.d46a468f.svg";